import React from 'react';

export default function SvgLeftCaret(props) {
  return (
    <svg
      width="9px"
      height="14px"
      viewBox="0 0 9 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>Icon / Arrow Left</title>
      <defs>
        <rect x="0" y="0" width="24" height="24"></rect>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-299.000000, -61.000000)">
          <g transform="translate(291.000000, 56.000000)">
            <mask fill="white">
              <use xlinkHref="#path-1"></use>
            </mask>
            <g></g>
            <path
              d="M16,5 L9,12 L16,19"
              stroke="#000000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray="0,0"
              mask="url(#mask-2)"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
